export default __webpack_public_path__ + "static/media/g2022-plan2.f494f12a.png";